/** Default matches glubes-api `AwsShared` (`glubes-web-assets`, `ap-northeast-2`). */
const DEFAULT_S3_PUBLIC_BASE = 'https://glubes-web-assets.s3.ap-northeast-2.amazonaws.com';

export function s3ObjectPublicUrl(key: string | null | undefined): string | null {
  if (!key?.trim()) return null;
  const base = (process.env.REACT_APP_S3_PUBLIC_BASE_URL || DEFAULT_S3_PUBLIC_BASE).replace(/\/$/, '');
  const path = key.trim().replace(/^\/+/, '');
  const encodedPath = path.split('/').map(encodeURIComponent).join('/');
  return `${base}/${encodedPath}`;
}
